import FJImageInputContainer from '../container/FJImageInputContainer';
import FJObjectEraseQuickSelectionBoxContainer from '../container/FJObjectEraseQuickSelectionBoxContainer';
import FJBrushCardTwoContainer from '../../../../common/components/FJBrushCard/FJBrushCardTwoContainer';
import FJGenerateButtonContainer from '../../../../common/combineComponents/FJGenerateButtonContainer/FJGenerateButtonContainer';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import styles from './FJObjectEraseBrash.module.less';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { OBJECT_ERASE_USE_CREDIT } from '../../../../redux/slices/FJSliceObjectErase';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';
import FJObjectEraseConfig from '../../../../config/appConfig/FJObjectEraseConfig.js';

const FJObjectEraseBrash = ({ isNotImage, disabled, taskStatus, isShow }) => {
    const text = useMemo(() => {
        if (taskStatus === FJConstant.START) {
            return 'start';
        } else if (taskStatus === FJConstant.GENERATING) {
            return 'removing';
        }
        return 'remove';
    }, [taskStatus]);

    const defaultFreeNumCreation = useDefaultFreeLimit(FJObjectEraseConfig.freeLimitType);

    return (
        <div className={classNames(styles.container, { [styles.show]: isShow })}>
            {isShow && <FJImageInputContainer />}
            {!isNotImage && (
                <>
                    <FJObjectEraseQuickSelectionBoxContainer />
                    <FJBrushCardTwoContainer />
                </>
            )}
            {!isNotImage && (
                <FJGenerateButtonContainer
                    text={text}
                    className={styles.generate_btn}
                    useCredit={OBJECT_ERASE_USE_CREDIT}
                    disabled={disabled}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                />
            )}
        </div>
    );
};

FJObjectEraseBrash.propTypes = {
    isNotImage: PropTypes.bool,
    disabled: PropTypes.bool,
    taskStatus: PropTypes.string,
    isShow: PropTypes.bool,
};

export default FJObjectEraseBrash;
